var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-btn',_vm._g(_vm._b({staticClass:"default",attrs:{"depressed":"","block":_vm.fullWidth}},'v-btn',_vm.$attrs,false),_vm.$listeners),[_vm._t("default",function(){return [_c('v-icon',[_vm._v("$app-chevron-left")])]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }